import { Http } from "app/Http/Http";
import { IList } from "shared/types/commonTypes";
import { IOrg } from "./types";

export const orgsApi = {
  get: () => {
    return Http.get<IList<IOrg>>(`/admin/org`);
  },
};
